import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';

export const BASE_PATH = '/dime-showcase';

export const COMPONENTS = [
  { label: 'Alert', path: `${BASE_PATH}/alert` },
  { label: 'Badge', path: `${BASE_PATH}/badge` },
  { label: 'Breadcrumbs', path: `${BASE_PATH}/breadcrumbs` },
  { label: 'Button', path: `${BASE_PATH}/button` },
  { label: 'ButtonDropdown', path: `${BASE_PATH}/button-dropdown` },
  { label: 'Checkbox', path: `${BASE_PATH}/checkbox` },
  { label: 'Divider', path: `${BASE_PATH}/divider` },
  { label: 'Drawer', path: `${BASE_PATH}/drawer` },
  { label: 'FilterGroup', path: `${BASE_PATH}/filter-group` },
  { label: 'FilterHeader', path: `${BASE_PATH}/filter-header` },
  { label: 'InsightLabel', path: `${BASE_PATH}/insight-label` },
  { label: 'Loader', path: `${BASE_PATH}/loader` },
  { label: 'Menu', path: `${BASE_PATH}/menu` },
  { label: 'Modal', path: `${BASE_PATH}/modal` },
  { label: 'Notification', path: `${BASE_PATH}/notification` },
  { label: 'NotificationBadge', path: `${BASE_PATH}/notification-badge` },
  { label: 'RadioButton', path: `${BASE_PATH}/radio-button` },
  { label: 'RemovableTag', path: `${BASE_PATH}/removable-tag` },
  { label: 'RichTextEditor', path: `${BASE_PATH}/rich-text-editor` },
  { label: 'SegmentedControl', path: `${BASE_PATH}/segmented-control` },
  { label: 'Select', path: `${BASE_PATH}/select` },
  { label: 'Switch', path: `${BASE_PATH}/switch` },
  { label: 'TagLabel', path: `${BASE_PATH}/tag-label` },
  { label: 'TextArea', path: `${BASE_PATH}/text-area` },
  { label: 'Tooltip', path: `${BASE_PATH}/tooltip` }
];

const NavPanel = styled.nav`
  width: 200px;
  min-width: 200px;
  height: 100%;
  overflow-y: auto;
  border-right: 1px solid #e5e7eb;
  padding: 16px 0;
  background: #fafafa;
`;

const NavHeader = styled.div`
  padding: 0 16px 12px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #9ca3af;
`;

const NavItem = styled(Link)<{ $active: boolean }>`
  display: block;
  padding: 7px 16px;
  font-size: 13px;
  text-decoration: none;
  color: ${({ $active }) => ($active ? '#7849FF' : '#374151')};
  background: ${({ $active }) => ($active ? '#f0ebff' : 'transparent')};
  font-weight: ${({ $active }) => ($active ? '600' : '400')};
  border-left: 3px solid
    ${({ $active }) => ($active ? '#7849FF' : 'transparent')};
  transition: background 0.15s, color 0.15s;

  &:hover {
    background: #f0ebff;
    color: #7849ff;
  }
`;

export const ComponentNav: React.FC = () => {
  const { pathname } = useLocation();
  const hasMatch = COMPONENTS.some(({ path }) => pathname === path);

  return (
    <NavPanel>
      <NavHeader>Components</NavHeader>
      {COMPONENTS.map(({ label, path }, idx) => (
        <NavItem
          key={path}
          to={path}
          $active={pathname === path || (!hasMatch && idx === 0)}
        >
          {label}
        </NavItem>
      ))}
    </NavPanel>
  );
};
